.headerButtonsIcons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.headerButton {
  @include themify($themes) {
    border: 1px solid themed("neutral-secondary");
    background-color: themed("main-secondary");
    color: themed("neutral-to-primary");
  }
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.25s ease-out;

  svg {
    width: 14px;
    height: 14px;
  }
  
  margin-left: 6px;

  &:not(.disabled):hover, &.selected {
    @include themify($themes) {
      background-color: themed("brand-secondary");
    }
  }

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }
}
